module.exports = __webpack_public_path__ + "img/2.fddc61fa.png";